import {Injectable} from '@angular/core';
import {HomeKpi} from "../../model/HomeKpi";
import {Chart} from 'chart.js';

/*
  Generated class for the LocupaChartsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocupaChartsServiceProvider {

  private green: string = '#00a65a';
  private red: string = '#DD4A39';
  private aqua: string = '#00C09E';
  private gold: string = '#F29B12';
  private lightblue: string = '#3c8dbc';
  private teal: string = '#39cccc';
  private purple: string = '#605ca8';

  public locupaCharsColor: string[] = [];

  constructor() {
    this.locupaCharsColor['green'] = this.green;
    this.locupaCharsColor['red'] = this.red;
    this.locupaCharsColor['aqua'] = this.aqua;
    this.locupaCharsColor['gold'] = this.gold;
    this.locupaCharsColor['lightblue'] = this.lightblue;
    this.locupaCharsColor['teal'] = this.teal;
    this.locupaCharsColor['purple'] = this.purple;
  }


  /**
   *
   * @param homeKpi
   * @param item
   */
  buildHomeKpiChart(homeKpi: HomeKpi, canvas: any) {


    let values: number[] = homeKpi.values;
    let colors: string[] = [];
    let labels: string[] = [];

    console.log("----")
    homeKpi.colors.forEach(c => {
      colors.push(this.locupaCharsColor[c]);
    });

    homeKpi.labels.forEach(l => {
      labels.push(l);
    })

    if (homeKpi.homeKpiType === 'NUMBER') {

    } else if (homeKpi.homeKpiType === 'PIE') {

      return new Chart(canvas.nativeElement, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [{
            label: "",
            backgroundColor: colors,
            borderColor: '#fff',
            data: values
          }]
        },

        options: {
          responsive: true,
          title: {
            display: true,
            text: homeKpi.title
          }, legend: {
            display: false
          }
        }
      });

    } else if (homeKpi.homeKpiType === 'KNOB') {

      return new Chart(canvas.nativeElement, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            label: "",
            backgroundColor: colors,
            borderColor: '#fff',
            data: values,
          }]
        },
        options: {
          circumference: 1 * Math.PI,
          rotation: 1 * Math.PI,
          cutoutPercentage: 50,
          title: {
            display: true,
            text: homeKpi.title
          },
          legend: {
            display: false
          }
        }
      });

    } else if (homeKpi.homeKpiType === 'BAR') {
      return new Chart(canvas.nativeElement, {
        type: 'horizontalBar',
        data: {
          labels: labels,
          datasets: [{
            label: "",
            backgroundColor: colors,
            borderColor: '#fff',
            data: values,
          }]
        },
        options: {
          responsive: true,
          legend: {display: false},
          title: {display: true, text: homeKpi.title}
        }
      });
    } else if (homeKpi.homeKpiType === 'STACKBARQuota') {

      let ds = [];
      for (let i = 0; i < values.length; i++) {
        ds.push({
          label: labels[i],
          backgroundColor: colors[i],
          borderColor: '#fff',
          data: [values[i]]
        });
      }

      return new Chart(canvas.nativeElement, {
        type: 'horizontalBar',
        data: {
          labels: [''],
          datasets: ds
        },

        options: {
          responsive: true,
          title: {display: true, text: homeKpi.title},
          scales: {
            xAxes: [{stacked: true}],
            yAxes: [{stacked: true}]
          }
        }
      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/providers/locupa-charts-service/locupa-charts-service.ts